let enableNetworkTracking = false;
let track: ((eventName: string, metric: unknown) => void) | undefined;

type NetworkMetric = {
  url: string;
  duration?: number;
  datasourceName?: string;
  activityTime?: number;
  screenContext?: { pageId: string };
};

const inProgressNetworkEventQueue = new Map<string, NetworkMetric>();

export const trackNetwork = (traceId: string, metric: NetworkMetric) => {
  if (!enableNetworkTracking) return;
  // track only node data source requests
  if (!metric.url?.includes('/node')) return;

  // if the request is in progress, add the metric to the queue and delete the in progress metric
  // else add the metric to the in progress queue
  const inProgressMetric = inProgressNetworkEventQueue.get(traceId);
  if (inProgressMetric) {
    inProgressNetworkEventQueue.delete(traceId);
    track?.('FETCH', {
      activityType: 'FETCH',
      activityTime: Date.now(),
      assetType: 'FETCH',
      assetId: inProgressMetric.datasourceName || inProgressMetric.url,
      attributes: {
        url: inProgressMetric.url,
        datasourceName: inProgressMetric.datasourceName,
      },
      metrics: { duration: Math.round(metric.duration || 0) },
    });
    cleanUpInProgressNetworkEventQueue();
  } else {
    const datasourceName = new URL(metric.url, window.location.origin).searchParams.get('name');
    inProgressNetworkEventQueue.set(traceId, {
      ...metric,
      activityTime: Date.now(),
      ...(datasourceName && { datasourceName }),
    });
  }
};

const CLEANUP_INTERVAL = 1000 * 60 * 5; // 5 minutes
// delete old in progress metrics after 5 minutes, if the request is not completed
const cleanUpInProgressNetworkEventQueue = () => {
  if (inProgressNetworkEventQueue.size === 0) return;

  const now = Date.now();
  inProgressNetworkEventQueue.forEach((metric, traceId) => {
    if (metric.activityTime && now - metric.activityTime > CLEANUP_INTERVAL) {
      inProgressNetworkEventQueue.delete(traceId);
    }
  });
};

export const setNetworkTracking = (
  enabled: boolean,
  _track: (eventName: string, metric: unknown) => void,
) => {
  enableNetworkTracking = enabled;
  track = _track;
};
